import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom';
import SpinErrorTable from './SpinErrorTable.js';
import MediaQuery from 'react-responsive';

import ReactTooltip from 'react-tooltip'
import { getColor } from '../../../common/ThemeService.js';

class SpinTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      open: false,
      currentStats: ''
    }
  }

  getCorlorCodForGrade = (grade) => {
    if (grade === 'A') return '#7ED321'
    if (grade === 'B') return '#7ED321'
    if (grade === 'C') return '#FFC814'
    if (grade === 'D') return '#FE8F40'
    if (grade === 'E') return '#FF4E3E'
  }

  logActivityHit = (lessons, stat, grade, e) => {
    let activityTrack = [],
      track = {
        hit_timestamp: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        session_id: localStorage.getItem("token"),
        userid: localStorage.getItem("username"),
        deviceInfo: JSON.parse(localStorage.getItem("deviceInfo")),
        hit_page: 'ReportCard',
        hit_type: 'ReportCardClinicVisit',
        hit_attribute1: stat,
        hit_attribute2: lessons,
        hit_attribute3: grade,
        hit_attribute4: this.props.summaryInfo.medal,
        hit_attribute5: ''
      }
    if (localStorage.getItem('activityTrack'))
      activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
    activityTrack.push(track)
    localStorage.setItem('activityTrack', JSON.stringify(activityTrack))
  }

  render() {
    const themeColor = getColor();
    const showModal = this.state.open ? 'displayBlock' : 'displayNone'
    return (
      <div>
        <style>
          {`.myErrorBtn {\
                           color: ${themeColor};\
                           border-color: ${themeColor} !important;\
                        }\
                    `}
        </style>
        <ReactTooltip />
        <div className={"missonmodal spinModal " + showModal} style={{ paddingLeft: '18px', paddingRight: '18px' }} >
          <div className='modalContent  respPadding spin-error-modal ' style={{ width: "100%", height: "auto" }}>
            <div className="bottom" style={{ paddingBottom: "16.42px" }}><span className="my-errors-heading">{this.props.i18next.t("lable.myErrors")}</span>
              <MediaQuery minWidth={992} >
                <button className="mg-btn greyBtnLiveReport btnHalo livestateTable_collapse_btn spin-Closebtn"
                  style={{ width: "80.4px", height: '33px', float: 'right' }} onClick={() => { this.setState({ open: false }) }}>
                  {this.props.i18next.t("lable.CLOSE")}
              </button>
              </MediaQuery>
              <MediaQuery maxWidth={991} >
                <i className="fa fa-times faCloseBtn" aria-hidden="true" onClick={() => { this.setState({ open: false }) }}></i>
              </MediaQuery>
              {/* <i class="fa fa-times" aria-hidden="true"></i> */}
            </div>
            {this.state.currentStats != '' && this.props.biggestErrorBySituations.filter((obj) => obj.situation === this.state.currentStats).length > 0
              && <SpinErrorTable
              i18next={this.props.i18next}
                category={'Tight Error'}
                ismodal={true}
                errorHands={this.props.biggestErrorBySituations.filter((obj) => obj.situation === this.state.currentStats)[0]}
                handReplayerOpen={(item) => this.props.handReplayerOpen(item)}
              />}
            {/* <div className="bottom" style={{ paddingBottom: "24.2px" }}></div> */}
          </div>
        </div>
        <table className="spinRepo_table" style={{
          width: "100%",
          fontSize: "14px",
          color: '#020202',
          marginTop: '17.45',
          backgroundColor: "white"
        }}>
          <thead className="resp-table-head spin-repo-bottom-border">
            <tr className="resp-table-tr">
              <th width='10%' className="resp_playerStat_th spinRepo_th">{this.props.i18next.t("lable.Stat")}</th>
              <th width='5%' className="resp_playerStat_th hide-prop spinRepo_th"></th>
              <th width='7%' className="resp_playerStat_th spinRepo_th">{this.props.i18next.t("lable.Grade")}</th>
              <th width='10%' className="resp_playerStat_th spinRepo_th">{this.props.i18next.t("lable.gradeRange")}</th>
              <th width='9%' className="resp_playerStat_th spinRepo_th">{this.props.i18next.t("lable.handsRequired")}</th>
              {/* <th width='9%' className="resp_playerStat_th spinRepo_th">Value&nbsp; */}
              <th width='1%' className="resp_playerStat_th spinRepo_th">&nbsp;
              {/* {['Postflop', 'Winrates'].indexOf(this.props.category) === - 1 &&
                  <i style={{ color: '#DE460F' }} className="fa fa-question-circle"
                    data-tip={'Average error measured in bb/100'} aria-hidden="true"></i>} */}
              </th>
              <th width='32%' className="resp_playerStat_th spinRepo_th">{this.props.i18next.t("lable.comment")}</th>
              <th width='8%' className="resp_playerStat_th spinRepo_th"></th>
            </tr>
          </thead>
          <tbody data-e2e="catInsideTable" className="resp-table-body">
            {this.props.playerStatistics.map((key, index) => {
              return (
                this.props.category == key.category &&
                <tr key={index} className="resp_playerStat_tr spin-tr-bottom" >
                  <td className="resp_playerStat_td spinRepo_td"><span >{key.stat}</span><i style={{ color: themeColor }} className="fa fa-question-circle mobileHeader" data-tip={key.toolTip} aria-hidden="true"></i></td>
                  <td style={{ padding: '0' }} className="resp_playerStat_td hide-prop spinRepo_td"><i style={{ color: themeColor }} className="fa fa-question-circle" data-tip={key.toolTip} aria-hidden="true"></i></td>
                  <td data-title='Grade:' className="resp_playerStat_td spinRepo_td">
                    <span className='cursive' style={{ color: this.getCorlorCodForGrade(key.grade), fontSize: '2em', fontWeight: 'bold' }}>
                      {key.grade}
                    </span>
                  </td>
                  <td data-title='Preferred Range:' className="resp_playerStat_td spinRepo_td">{key.prefRange}</td>
                  <td data-title='Minimum Hands Required:' className="resp_playerStat_td spinRepo_td">{key.minimum_hand_requirement}
                    {key.minimum_hand_requirement < this.props.handsAnalysed || key.minimum_hand_requirement == this.props.handsAnalysed
                      ? null
                      :
                      <i style={{ color: '#DE460F' }} className="fa fa-exclamation-triangle" data-tip='Insufficient hands played for this statistic to be reliable' aria-hidden="true"></i>
                    }
                  </td>
                  {/* <td data-e2e="reportCardValues" data-title='Value' className="resp_playerStat_td spinRepo_td">{key.value != null ? key.value : "INF"}</td> */}
                  <td data-e2e="reportCardValues" data-title='' className="resp_playerStat_td spinRepo_td">{""}</td>
                  <td data-title='Comment:' style={{ fontSize: 12 }} className="resp_playerStat_td spinRepo_td">{key.comment}</td>
                  <td className="resp_playerStat_td resp_playerStat_td_livereport spinRepo_td">
                    {
                      ['Postflop', 'Winrates'].indexOf(this.props.category) === - 1 &&
                        this.props.biggestErrorBySituations.filter((obj) => obj.situation === key.stat).length > 0
                        ? <button data-e2e={key.stat}
                          className="mg-btn myErrorBtn"
                          onClick={() => { this.setState({ open: true, currentStats: key.stat.endsWith("6-12") ? key.stat.replace("6-12", '12-') : key.stat }) }}
                          style={{ cursor: 'pointer', minWidth: "200px", backgroundColor: 'white' }}
                        >{this.props.i18next.t("lable.MYERRORS")}</button>
                        :  ['Postflop', 'Winrates'].indexOf(this.props.category) === - 1 &&<button data-e2e={key.stat}
                          className="mg-btn NoErrorBtn"
                          style={{ cursor: 'alias', minWidth: "200px", backgroundColor: 'white' }}
                        >{this.props.i18next.t("lable.NOERRORS")}</button>
                    }
                  </td>
                </tr>
              )
            })}

          </tbody>
        </table>
      </div>
    );
  }
}
export default withRouter(SpinTable);


/** WEBPACK FOOTER **
 ** ./src/components/ReportCard/Spin/SpinTable.js
 **/